import { createSlice } from '@reduxjs/toolkit';

import { getDailyChallengeForPreview } from './actions';

const dailyChallengeSlice = createSlice({
  name: 'currentDailyChallenge',
  initialState: null as any,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(
      getDailyChallengeForPreview.fulfilled,
      (_: any, action: any) => {
        return action.payload;
      },
    );
  },
});

export default dailyChallengeSlice.reducer;
